<template>
  <div class="productDetail_wrap" v-loading="loading">
    <div class="productDetail_con">
      <div class="productDetail_title">{{title}}</div>
      <div class="product_time">发布时间：{{publishTime}}</div>
      <!-- 用v-html渲染富文本，替代手动DOM操作 -->
      <div class="productDetail_item" v-html="richTextContent"></div>
    </div>
    <div class="back-btn" @click="handleBack">返回</div>
  </div>
</template>

<script>
import {getGroupInfoById, getJournalismById, selectListByArticle} from "@/api/home";
import {NodeIdEnum} from "@/enums/nodeIdEnum";

export default {
  name: "NewsDetail",
  data() {
    return {
      loading: false,
      richTextContent: "", // 存储过滤后的富文本内容
      title: "", //新闻标题
      publishTime: '',//发布时间
      // 维护type
      apiTypeMap: {
        home_news: "home_news", // 调用首页新闻中心展示详情接口
        chairman_profile: "chairman_profile", // 调用董事长下的新闻详情接口
        contest_news: "contest_news",
      },
    };
  },
  watch: {
    "$route.query": {
      immediate: true,
      handler(newQuery) {
        const { newsId, type } = newQuery;
        // 先校验必填参数
        if (!newsId) {
          this.$message.warning("新闻ID不能为空");
          this.richTextContent = "";
          return;
        }
        if (!type) {
          this.$message.warning("类型参数不能为空");
          this.richTextContent = "";
          return;
        }
        // 调用通用获取详情方法
        this.getDetailByType(type, newsId);
      },
    },
  },
  methods: {
    // 返回上一页
    handleBack() {
      this.$router.go(-1);
    },
    // 调用通用获取详情方法
    async getDetailByType(type, id){
      if(type === this.apiTypeMap.home_news){
        await this.getJournalismById(id);
      }else if(type === this.apiTypeMap.chairman_profile){
        await this.getGroupInfoById(id);
      }else if(type === this.apiTypeMap.contest_news){
        await this.selectListByArticle(id);
      }
    },

    //首页新闻中心
    async getJournalismById(newsId) {
      try {
        this.loading = true;
        const res = await getJournalismById(newsId);
        if (res.code === 200) {
          this.richTextContent = res.data.richText;
          this.title = res.data.name;
          this.publishTime = res.data.publishTime;
        } else {
          this.$message.error(res.msg || "获取新闻中心详情失败");
          this.richTextContent = "";
          this.title = "";
        }
      } catch (error) {
        this.$message.error("网络异常，请稍后重试");
        this.richTextContent = "";
        this.title = "";
      } finally {
        this.loading = false;
      }
    },
    //董事长简介下的新闻中心
    async getGroupInfoById(newsId) {
      try {
        this.loading = true;
        const res = await getGroupInfoById(newsId);
        if (res.code === 200) {
          const data = res.data[0];
          this.richTextContent = data.richText;
          this.title = data.name;
          this.publishTime = data.publishTime;
        } else {
          this.$message.error(res.msg || "获取新闻中心详情失败");
          this.richTextContent = "";
          this.title = "";
        }
      } catch (error) {
        this.$message.error("网络异常，请稍后重试");
        this.richTextContent = "";
        this.title = "";
      } finally {
        this.loading = false;
      }
    },
    //赛事详情
    async selectListByArticle(newsId) {
      try {
        this.loading = true;
        const res = await selectListByArticle(newsId,NodeIdEnum.ARTICLE_TYPE_QYDT_ID.value);
        if (res.code === 200) {
          console.log(121,res);
          const data = res.data;
          this.richTextContent = data.content;
          this.title = data.title;
          this.publishTime = data.time;
        } else {
          this.$message.error(res.msg || "获取新闻中心详情失败");
          this.richTextContent = "";
          this.title = "";
        }
      } catch (error) {
        this.$message.error("网络异常，请稍后重试");
        this.richTextContent = "";
        this.title = "";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
// 补充基础布局：确保body/html高度占满，避免居中失效
html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

// 父容器：水平居中 + 可选垂直居中（根据需求）
.productDetail_wrap {
  width: 80%; // 容器宽度可根据需求调整（比如70%/1200px）
  height: 100%;
  margin: 0 auto; // 核心：水平居中（最常用）
  padding-top: 150px;
  max-width: 1200px;
  box-sizing: border-box;

  // ========== 移动端适配（768px以下） ==========
  @media (max-width: 768px) {
    width: 95%; // 移动端几乎占满屏幕，留少量边距
    padding-top: 80px; // 减小顶部间距
    max-width: none; // 移除最大宽度限制
    padding-left: 10px; // 左右内边距，避免内容贴边
    padding-right: 10px;
  }

  // ========== 手机端适配（480px以下） ==========
  @media (max-width: 480px) {
    width: 98%; // 进一步加大宽度
    padding-top: 60px; // 进一步减小顶部间距
  }

  // 新增：返回按钮样式
  .back-btn {
    width: 120px;       // 固定宽度
    height: 40px;       // 固定高度
    line-height: 40px;  // 行高等于高度，文字垂直居中
    background: #d26b6b;// 背景色
    color: #fff;        // 文字白色
    text-align: center; // 文字水平居中
    margin: 50px auto;  // 按钮整体水平居中，上下间距50px
    border-radius: 4px; // 轻微圆角，提升美观
    cursor: pointer;    // 鼠标悬浮显示手型
    transition: background 0.2s; // 背景色过渡动画

    // 移动端按钮适配
    @media (max-width: 768px) {
      width: 100px; // 减小宽度
      height: 36px; // 减小高度
      line-height: 36px;
      margin: 30px auto; // 减小上下间距
      font-size: 14px; // 减小字体
    }

    @media (max-width: 480px) {
      width: 90px;
      height: 32px;
      line-height: 32px;
      margin: 20px auto;
      font-size: 13px;
      border-radius: 3px; // 减小圆角
    }

    // 悬浮效果
    &:hover {
      background: #c15a5a; // 略深的同色系，提升交互反馈
    }
  }

  .productDetail_title{
    font-size: 30px;
    font-weight: bold;
    color: #333333;
    border-bottom: 1px solid #e3e3e3;
    line-height: 80px;

    // 移动端标题适配
    @media (max-width: 768px) {
      font-size: 22px; // 减小字体
      line-height: 50px; // 减小行高
      border-bottom: 1px solid #f0f0f0; // 浅色边框更柔和
    }

    @media (max-width: 480px) {
      font-size: 15px; // 进一步减小
      line-height: 25px;
    }
  }

  .product_time{
    line-height: 50px;
    color: #989898;
    font-size: 16px;

    // 移动端时间适配
    @media (max-width: 768px) {
      line-height: 35px; // 减小行高
      font-size: 14px; // 减小字体
    }

    @media (max-width: 480px) {
      line-height: 30px;
      font-size: 13px;
    }
  }

  // 子容器：内容居中
  :deep(.productDetail_item) {
    padding-top: 50px;
    width: 100%;
    min-height: calc(100% - 200px); // 确保内容区域高度足够
    box-sizing: border-box; // 防止padding/margin撑宽容器

    // 移动端富文本间距适配
    @media (max-width: 768px) {
      padding-top: 25px; // 减小顶部间距
    }

    @media (max-width: 480px) {
      padding-top: 20px;
    }

    p {
      img {
        width: 100% !important;
        height: auto; // 自适应高度，防止变形
        margin: 0 auto; // 兜底：确保图片块级居中
        display: block; // 强制块级，确保margin生效
      }

      // 移动端段落行高优化
      @media (max-width: 768px) {
        font-size: 15px;
        line-height: 1.7; // 减小行高，提升阅读效率
        margin-bottom: 12px; // 减小段落间距
      }

      @media (max-width: 480px) {
        font-size: 14px;
        line-height: 1.6;
        margin-bottom: 10px;
      }
    }

    // 富文本中块级元素（表格/容器）居中
    table,
    .rich-text-container,
    iframe {
      margin: 0 auto; // 块级元素水平居中
      max-width: 100%; // 不超出父容器
      // 移动端表格适配
      @media (max-width: 480px) {
        width: 100% !important;
        overflow-x: auto; // 表格超出可横向滚动
        display: block;
      }
    }

    // 兼容其他富文本标签
    img,
    video {
      height: auto;
      max-height: 80vh; // 限制图片最大高度，避免超出屏幕
    }

    p,
    div,
    span {
      line-height: 1.8; // 优化行高，提升可读性
      // 移动端通用文字适配
      @media (max-width: 768px) {
        font-size: 15px;
        line-height: 1.7;
      }

      @media (max-width: 480px) {
        font-size: 14px;
        line-height: 1.6;
      }
    }

    // 移动端标题类文字适配
    h1, h2, h3, h4, h5, h6 {
      @media (max-width: 768px) {
        font-size: calc(100% + 2px); // 按比例缩小
        margin-top: 15px;
        margin-bottom: 10px;
      }

      @media (max-width: 480px) {
        font-size: 100%;
        margin-top: 12px;
        margin-bottom: 8px;
      }
    }
  }
}
</style>